import { render, staticRenderFns } from "./userlist.vue?vue&type=template&id=225e4c53&scoped=true"
import script from "./userlist.vue?vue&type=script&lang=js"
export * from "./userlist.vue?vue&type=script&lang=js"
import style0 from "./userlist.vue?vue&type=style&index=0&id=225e4c53&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e4c53",
  null
  
)

export default component.exports